
import { useEffect, useState } from 'react';
import { getTestimonials } from '../../../api/apiServices';

export default function TestimonialSection() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      fetchTestimonials();
    }, []);
  
    const fetchTestimonials = async () => {
      try {
        setLoading(true);
        const res = await getTestimonials();
        setTestimonials(res.data || []);
      } catch (err) {
        console.error("Failed to load testimonials", err);
      } finally {
        setLoading(false);
      }
    };

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-20 bg-gradient-to-b from-[#f5f3fb] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left - Image */}
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl w-full h-[350px] sm:h-[400px] lg:h-[500px]">
              <img
                src={current?.image}
                alt={current?.author}
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:col-span-3 order-1 lg:order-2">
            <p className="text-gray-500 text-sm mb-3 sm:mb-4">(Survivor Testimony)</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 sm:mb-8 lg:mb-12 leading-tight">
              <span className="text-gray-900">Finding Strength</span>
              <br />
              <span className="text-gray-400">Through Support</span>
            </h2>

            <blockquote className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
              "{current?.quote}"
            </blockquote>

            <p className="text-base sm:text-lg font-bold text-gray-900 mb-8 sm:mb-12">
              — {current?.author}, {current?.role}
            </p>

            {/* Navigation */}
            <div className="flex gap-3 sm:gap-4">
              <button
                onClick={prevTestimonial}
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-600 hover:border-[#c9a24d] hover:text-[#c9a24d] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
              </button>
              <button
                onClick={nextTestimonial}
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#c9a24d] flex items-center justify-center text-white hover:bg-[#b8923d] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
